import React from "react";
import { ListPlus } from "@/components/icons";
import { useAuth } from "@/context/AuthContext";

// Quick capture lives in the sidebar, as a nav item. The floating button is gone
// (deleted, not repositioned) and the console never carries it.
//
// The DIALOG does not live here. On a phone this button sits inside the nav
// Sheet, and Radix unmounts that subtree when the sheet closes — a dialog
// rendered as a child of this button was torn down ~300ms after opening, which
// made quick capture unusable on the only device used in a wash bay. AppShell
// owns the dialog and renders it as a sibling of the Sheet; this button only
// asks for it.
export const PuntNavItem = ({ onOpen }) => {
  const { canWrite } = useAuth();
  if (!canWrite()) return null;

  return (
    <button
      type="button"
      data-testid="nav-punt"
      onClick={onOpen}
      className="flex w-full items-center gap-3 rounded px-3 py-2 text-left text-body text-white transition-colors duration-150 hover:bg-console-diep"
    >
      <ListPlus size={20} />
      <span>Punt noteren</span>
    </button>
  );
};
